import PropTypes from 'prop-types'
import { Box, Chip, Link } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'
import { useStyles } from '../styles'

const FilteringChipsView = ({ filters, handleClearFilters }) => {
  const t = useTranslations()
  const classes = useStyles()

  if (!filters || filters.length === 0) return null
  return (
    <Box className={classes.filters}>
      {filters.map(({ key, labelTitle, labelDescription, deleteFilter }) => {
        const label = labelTitle ? (
          <>
            <span>{labelTitle}</span> {labelDescription}
          </>
        ) : (
          labelDescription
        )
        return (
          <Chip key={key} label={label} onDelete={deleteFilter ?? undefined} />
        )
      })}
      {handleClearFilters ? (
        <Link component="button" onClick={handleClearFilters}>
          {t('action:clean-filters')}
        </Link>
      ) : null}
    </Box>
  )
}

FilteringChipsView.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      labelTitle: PropTypes.node,
      labelDescription: PropTypes.node.isRequired,
      deleteFilter: PropTypes.func,
    }),
  ),
  handleClearFilters: PropTypes.func,
}

export default FilteringChipsView
